/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Model_PlaceholderInputs */

const en_byoa_model_placeholder = /** @type {(inputs: Byoa_Model_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model name, e.g. claude-sonnet-4-6`)
};

const id_byoa_model_placeholder = /** @type {(inputs: Byoa_Model_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama model, mis. claude-sonnet-4-6`)
};

/**
* | output |
* | --- |
* | "Model name, e.g. claude-sonnet-4-6" |
*
* @param {Byoa_Model_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_model_placeholder = /** @type {((inputs?: Byoa_Model_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Model_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_model_placeholder(inputs)
	return en_byoa_model_placeholder(inputs)
});